import { useLocalStorage } from "@vueuse/core";

export default () => {
	const queryParams = useLocalStorage("query-params", {});

	const getQueryParams = () => {
		return queryParams.value;
	};

	const getQueryParam = (param) => {
		if (!param) return null;
		if (!(param in queryParams.value)) return null;

		return queryParams.value[param];
	};

	const addQueryParam = (key, value) => {
		if (value === null) {
			deleteQueryParam(key);
			return;
		}

		queryParams.value = {
			...queryParams.value,
			[key]: value,
		};
	};

	const deleteQueryParam = (key) => {
		const params = { ...queryParams.value };
		delete params[key];
		queryParams.value = params;
	};

	return {
		getQueryParams,
		getQueryParam,
		addQueryParam,
		deleteQueryParam,
	};
};
